import { createClient } from 'contentful';

import { env } from '@/env';

export const contentfulClient = createClient({
  space: env.contentfulSpaceId,
  environment: env.contentfulEnvironment,
  accessToken: env.contentfulAccessToken,
});
